export enum UpsellStage {
  Prologue = 'PROLOGUE',
  Verification = 'VERIFICATION',
  Epilogue = 'EPILOGUE'
}

export enum IDVPage {
  VendorLink,
  Checklist,
  Complete
}
